import { render, staticRenderFns } from "./EmployeeRoleEdit.vue?vue&type=template&id=bf834eba&scoped=true&"
import script from "./EmployeeRoleEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf834eba",
  null
  
)

export default component.exports